import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';

export const StepContentWrapper = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    '& > div': {},
  },
}));
